import { Skeleton } from './Skeleton'

// Suspense fallback for lazy-loaded route chunks. It renders inside the layout
// shell's content area (the sidebar / admin tabs stay put), so it only fills
// the page body for the brief moment a route's JS chunk is in flight. Mirrors
// the skeleton idiom the pages themselves use while their data loads, so the
// hop from "chunk loading" to "data loading" reads as one continuous wait.
export function RouteFallback() {
  return (
    <div
      className="flex flex-col gap-5"
      role="status"
      aria-busy="true"
      aria-label="A carregar página…"
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-56" />
        <Skeleton className="h-4 w-80" />
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        <Skeleton className="h-20" />
        <Skeleton className="h-20" />
        <Skeleton className="h-20" />
      </div>
      <Skeleton className="h-72 w-full" />
    </div>
  )
}
